var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useState } from "react";
import { Controller, } from "react-hook-form";
import { InputLabel, InputAdornment } from "@mui/material";
import { Text } from "../Text";
import { Container, Input, FeedBackMessage, ButtonStyled } from "./styles";
function InputBaseWithoutRef(_a, ref) {
    var name = _a.name, label = _a.label, error = _a.error, errorText = _a.errorText, control = _a.control, defaultValues = _a.defaultValues, rest = __rest(_a, ["name", "label", "error", "errorText", "control", "defaultValues"]);
    var _b = __read(useState(false), 2), showPassword = _b[0], setShowPassword = _b[1];
    var handleShowPassword = function (event) {
        event.stopPropagation();
        setShowPassword(function (prevState) { return !prevState; });
    };
    var handleMouseDownPassword = function (event) {
        event.preventDefault();
        event.stopPropagation();
    };
    return (_jsxs(Container, { children: [label && _jsx(InputLabel, __assign({ htmlFor: name }, { children: label })), _jsx(Controller, { name: name, control: control, defaultValue: defaultValues, render: function (_a) {
                    var _b = _a.field, onChange = _b.onChange, value = _b.value;
                    return (_jsx(Input, __assign({}, rest, { inputRef: ref, fullWidth: true, type: showPassword ? "text" : rest.type, error: !!errorText || error, onChange: onChange, value: value || "", endAdornment: rest.type === "password" ? (_jsx(InputAdornment, __assign({ position: "end" }, { children: _jsx(ButtonStyled, __assign({ onClick: handleShowPassword, onMouseDown: handleMouseDownPassword }, { children: _jsx(Text, __assign({ textStyle: "button3", color: "tangerine" }, { children: showPassword ? "ocultar" : "exibir" })) })) }))) : null })));
                } }), !!errorText && _jsx(FeedBackMessage, { children: errorText })] }));
}
export var InputBase = forwardRef(InputBaseWithoutRef);
